import { getErrorContext } from './getErrorContext';
export class DataFetchingError extends Error {
  constructor(message, extra) {
    super(message, {
      cause: extra.cause
    });
    this.errorType = 'DataFetchingError';
    this.extra = extra;
  }
}
export const isDataFetchingError = error => error instanceof DataFetchingError;
export const getDataFetchingErrorContext = error => {
  const {
    message,
    stack,
    cause
  } = error;
  return {
    extra: {
      message,
      stack,
      cause: getErrorContext(cause),
      statusCode: error.extra.statusCode
    },
    fingerprint: ['DataFetchingError', message],
    tags: {
      errorType: 'DataFetchingError'
    }
  };
};